module.exports = __webpack_public_path__ + "img/Oval2.4678a88a.png";